import React from 'react';
import { FLIPGIVE_WALLET_URL } from 'common/env';
import { useConfigureUrlWithAffiliateToken } from 'common/hooks/useGetAffiliateActivationUrl';
import { ActivityIndicator } from 'components/activity-indicator/ActivityIndicator';

export const FlipgiveWalletIframe: React.FC = () => {
    const [url, isLoading] = useConfigureUrlWithAffiliateToken('<token>', FLIPGIVE_WALLET_URL);

    if (isLoading) {
        return <ActivityIndicator />;
    }

    if (!url) {
        return <p>Unable to load FlipGive wallet</p>;
    }

    return (
        <section>
            <h2 className="hidden sm:block text-3xl text-brand-dark font-normal mt-0 mb-8">
                Legacy Gift Cards
            </h2>
            <iframe
                src={url}
                title="Legacy Gift Cards"
                className="w-full block bg-white border-0 sm:border-t sm:border-grey-3"
                style={{ height: 'calc(100vh - 220px)' }}
                allow="clipboard-write"
                scrolling="yes"
            />
        </section>
    );
};

export default FlipgiveWalletIframe;
